import { generateIconsFromConfiguration } from '../../helpers/dataTableActionIconHelper'
import { ActionIcons } from '../../model'
import { regulatoryReportDownloadCard } from './regulatoryReports.Model'
import { filterApplicableActionsConfigurationRemit } from './regulatoryReports.service'

export const completeDataTableActions = (
  item: regulatoryReportDownloadCard
): regulatoryReportDownloadCard => {
  return {
    ...item,
    actions:
      item.actionsConfiguration &&
      item.actionsConfiguration.length > 0 &&
      generateIconsFromConfiguration(
        item,
        filterApplicableActionsConfigurationRemit(item, item.actionsConfiguration),
        new Map<ActionIcons, Function>([])
      )
  }
}
